module.exports = __webpack_public_path__ + "img/blauetonne.246c9c82.svg";